import { useParams, Link } from 'react-router-dom'
import { useMemo } from 'react'
import { Container } from '@/components/layout/Container'
import { ProductGrid } from '@/components/sections/ProductGrid'
import { useCatalogue } from '@/hooks/useCatalogue'


export function CollectionDetail() {
  const { slug } = useParams()
  const { products, collections, loading } = useCatalogue()

  const collection = useMemo(() => collections.find((c) => c.slug === slug), [collections, slug])

  const perfumes = useMemo(() => {
    if (!collection) return []
    return collection.perfumeIds
      .map((id) => products.find((p) => p.id === id))
      .filter((p): p is NonNullable<typeof p> => !!p)
  }, [collection, products])

  if (loading && !collection) {
    return (
      <Container className="py-32 text-center">
        <p className="text-carbon/60">Loading collection...</p>
      </Container>
    )
  }

  if (!collection) {
    return (
      <Container className="py-32 text-center">
        <h1 className="font-display text-3xl text-carbon">Collection not found</h1>
        <Link to="/collections" className="mt-4 inline-block text-carbon hover:underline">Back to collections</Link>
      </Container>
    )
  }

  return (
    <div className="pt-28 pb-24">
      <div className="relative h-[50vh] min-h-[360px]">
        <img
          src={collection.image}
          alt={collection.name}
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-ink/50" />
        <div className="absolute inset-0 flex items-center">
          <Container>
            <p className="mb-3 text-xs uppercase tracking-[0.15em] text-wd-orange">{collection.tagline}</p>
            <h1 className="font-display text-5xl normal-case text-white md:text-6xl">
              {collection.name.toLowerCase()}
            </h1>
            <p className="mt-4 max-w-xl text-white/80">{collection.description}</p>
          </Container>
        </div>
      </div>

      <Container className="mt-16">
        <ProductGrid perfumes={perfumes} />
      </Container>
    </div>
  )
}
